CreateCaseCtrl.$inject = ['$scope', '$rootScope', '$location', 'Case',
  'CurrentCase', 'CaseMap', '$sce', '$timeout'
]

export default function CreateCaseCtrl($scope, $rootScope, $location, Case,
  CurrentCase, CaseMap, $sce, $timeout) {

  // The selected case copy source should stay set after closing the create
  // case modal. If the selected case isn't available when reopening the
  // modal, it should be set to the current case.
  if (!$scope.selectedCase) {
    $scope.selectedCase = CurrentCase.data || {};
  }

  $timeout(() => {
    // focus on show, slight delay for safari and firefox
    document.querySelector('#displayName').focus();
  }, 100, false)


  CaseMap.api.get().then(data => {
    $scope.cases = CaseMap.toArray()
  });

  // copy.enabled shows copy options in the modal, and determines wether
  // the a case should be created or copied.
  $scope.copy = {
    enabled: false,
    options: {}
  };

  $scope.selectCase = function (caze) {
    $scope.selectedCase = caze;
  };

  $scope.scratch = {};
  $scope.createButtonStates = {
    false: $sce.trustAsHtml('Create'),
    true: $sce.trustAsHtml(
      'Creating... <i class="font-icon-sm icon-spinner icon-spin">')
  };

  $scope.submit = function () {
    // If user opts to copy, a case to copy from should be given
    if ($scope.copy.enabled && !$scope.selectedCase.id) {
      $scope.validations = {
        caseId: {
          error: 'Please select a case to copy.'
        }
      };
      return;
    }

    // successful Create + Copy callback
    var setCase = function (data) {
      CaseMap.set(data.id, data);

      $scope.$close(data);
    };
    // unsuccessful Create + Copy callback
    var setError = function (response) {
      $scope.validations = response.data.data;
    };

    var newCase = new Case();
    newCase.data.displayName = $scope.scratch.displayName;
    if ($scope.copy.enabled) {

      newCase.api.copy({
        copyCaseId: $scope.selectedCase.id
      }).then(setCase, setError);
    } else {
      newCase.data.status = 'active';
      newCase.api.create().then(setCase, setError);
    }

  };
}



// WEBPACK FOOTER //
// ./project/modals/create-case/create-case.controller.js